import { render } from "./EmbedContainer.vue?vue&type=template&id=7f36bc1e"
import script from "./EmbedContainer.vue?vue&type=script&lang=js"
export * from "./EmbedContainer.vue?vue&type=script&lang=js"
script.render = render

export default script